( function( $ ) {
    'use strict';

    $( function() {
    	const $offcanvas = $( '.js-site-offcanvas' );
    	const $trigger = $( '.js-site-offcanvas-trigger' );
    	const $content = $( '.js-offcanvas-content' );
    	const activeClass = 'site-offcanvas--is-active';

	    const deregisterCloseHandler = () => {
		    $( document ).off( 'click.wellfit.offcanvas.close' );
	    };

    	const registerCloseHandler = () => {
    		$( document ).on( 'click.wellfit.offcanvas.close', function( event ) {
    			let $target = $( event.target );

    			if ( ! $target.is( $content ) && ! $target.parents().is( $content ) && ! $target.is( $trigger ) && ! $target.parents().is( $trigger ) ) {
    				if ( $offcanvas.hasClass( activeClass ) ) {
					    $offcanvas.removeClass( activeClass );
					    deregisterCloseHandler();
				    }
			    }
		    } );
	    };

    	const registerClickHandler = () => {
		    $trigger.on( 'click', function() {
			    $offcanvas.toggleClass( activeClass );

			    if ( $offcanvas.hasClass( activeClass ) ) {
				    registerCloseHandler();
			    } else {
				    deregisterCloseHandler();
			    }
		    } );
	    };

    	registerClickHandler();


    } );
} )( jQuery );
